/**
 * @generated SignedSource<<d5e8254e92a76e5957e288e2a7f1f1ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NotificationsSubscriptionsViaToken = {
  token: string;
};
export type UnsubscribeViaTokenQuery$variables = {
  input: NotificationsSubscriptionsViaToken;
};
export type UnsubscribeViaTokenQuery$data = {
  readonly notificationSubscriptionsViaToken: {
    readonly " $fragmentSpreads": FragmentRefs<"UnsubscribeCard_notificationSubscriptions">;
  };
};
export type UnsubscribeViaTokenQuery = {
  response: UnsubscribeViaTokenQuery$data;
  variables: UnsubscribeViaTokenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnsubscribeViaTokenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NotificationSubscriptions",
        "kind": "LinkedField",
        "name": "notificationSubscriptionsViaToken",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UnsubscribeCard_notificationSubscriptions"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnsubscribeViaTokenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NotificationSubscriptions",
        "kind": "LinkedField",
        "name": "notificationSubscriptionsViaToken",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "surveyInvites",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cf6c8068e1b8848c20c502e209cbfe20",
    "id": null,
    "metadata": {},
    "name": "UnsubscribeViaTokenQuery",
    "operationKind": "query",
    "text": "query UnsubscribeViaTokenQuery(\n  $input: NotificationsSubscriptionsViaToken!\n) {\n  notificationSubscriptionsViaToken(input: $input) {\n    ...UnsubscribeCard_notificationSubscriptions\n    id\n  }\n}\n\nfragment UnsubscribeCard_notificationSubscriptions on NotificationSubscriptions {\n  id\n  surveyInvites\n}\n"
  }
};
})();

(node as any).hash = "80582fff36d0abe1d3bbbef58f200e63";

export default node;
